<template>
  <a class="weui_cell" href="javascript:">
    <div class="weui_cell_bd weui_cell_content">
      <p>{{title}}</p>
      <inline-desc v-if="inlineDesc">{{inlineDesc}}</inline-desc>
    </div>
    <div class="weui_cell_ft vux-cell-primary vux-datetime-value" :style="{textAlign: valueTextAlign}">
      {{ currentValue }}
      <span class="cvux-datetime-placeholder" v-if="!currentValue.length && placeholder" v-html="placeholder"></span>
    </div>
    <div class="with_arrow">
      <icon class="vux-input-icon" type="warn" v-show="!valid" :title="firstError"></icon>
    </div>
  </a>
</template>
<script>
import Icon from '../icon'
import Picker from './datetimepicker'
import Group from '../group'
import InlineDesc from '../inline-desc'
import Base from '../../libs/base'

export default {
  mixins: [Base],
  components: {
    Group,
    InlineDesc,
    Icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: {
      type: String,
      default: 'ok'
    },
    cancelText: {
      type: String,
      default: 'cancel'
    },
    clearText: {
      type: String,
      default: ''
    },
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: String,
    endDate: String,
    valueTextAlign: String
  },
  mounted() {
    const uuid = this.uuid
    this.$nextTick(() => {
      this.$el.setAttribute('id', 'vux-datetime-' + uuid)
      this.render()
    })
  },
  computed: {
    pickerOptions() {
      const _this = this
      const options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: this.confirmText,
        cancelText: _this.cancelText,
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        onConfirm(value) {
          _this.currentValue = value
        },
        onClear(value) {
          _this.$emit('on-clear', value)
        },
        onHide() {
          _this.validate()
        }
      }
      if (this.minYear) {
        options.minYear = this.minYear
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear
      }
      return options
    },
    firstError() {
      let key = Object.keys(this.errors)[0]
      return this.errors[key]
    }
  },
  methods: {
    render() {
      if (this.picker) {
        this.picker.destroy()
      }
      this.picker = new Picker(this.pickerOptions)
    },
    validate() {
      if (!this.currentValue && this.required) {
        this.valid = false
        this.errors.required = this.title + '必填'
        // return
      } else {
        this.valid = true
        this.errors = {}
      }
      this.$emit('on-vali', this.errors, this.valid, this.uuid)
    }
  },
  created() {
    this.currentValue = this.value
    this.handleChangeEvent = true
  },
  data() {
    return {
      currentValue: null,
      valid: true,
      errors: {}
    }
  },
  watch: {
    currentValue(val) {
      if (this.value !== val) {
        this.$emit('on-change', val)
      }
      this.$emit('input', val)
      this.validate()
    },
    value(val) {
      if (this.currentValue !== val) {
        this.currentValue = val
        this.picker && this.picker.destroy()
        this.render()
      }
    },
    startDate() {
      this.render()
    },
    endDate() {
      this.render()
    }
  },
  beforeDestroy() {
    this.picker && this.picker.destroy()
  }
}
</script>
<style lang="less">
@import '../../styles/cui/widget/cui_cell/cui_cell_global';
.with_arrow:after {
  content: " ";
  display: inline-block;
  transform: rotate(45deg);
  height: 8/@w;
  width: 8/@w;
  border-width: 1px 1px 0 0;
  border-color: #a0a0a0;
  border-style: solid;
  position: relative;
  top: -1px;
  margin-left: .3em;
}
.scroller-component {
  display: block;
  position: relative;
  height: 238/@w;
  overflow: hidden;
  width: 100%;
}

.scroller-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: -1;
}

.scroller-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  margin: 0 auto;
  width: 100%;
  z-index: 3;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), linear-gradient(to top, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));
  background-position: top, bottom;
  background-size: 100% 102/@w;
  background-repeat: no-repeat;
}

.scroller-item {
  text-align: center;
  font-size: 16/@w;
  height: 34/@w;
  line-height: 34/@w;
  color: #000;
}

.scroller-indicator {
  width: 100%;
  height: 34/@w;
  position: absolute;
  left: 0;
  top: 102/@w;
  z-index: 3;
  background-image: linear-gradient(to bottom, #d0d0d0, #d0d0d0, transparent, transparent), linear-gradient(to top, #d0d0d0, #d0d0d0, transparent, transparent);
  background-position: top, bottom;
  background-size: 100% 1px;
  background-repeat: no-repeat;
}

.dp-container {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 10000;
  background-color: #fff;
  display: none;
  transition: transform 0.3s ease;
  transform: translateY(100%);
}

.dp-mask {
  z-index: 998;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  opacity: 0;
  transition: opacity 0.1s ease;
  background-color: #000;
  z-index: 9999;
}

.dp-header {
  display: flex;
  width: 100%;
  box-align: center;
  align-items: center;
  background-image: linear-gradient(to bottom, #e7e7e7, #e7e7e7, transparent, transparent);
  background-position: bottom;
  background-size: 100% 1px;
  background-repeat: no-repeat;
}

.dp-header .dp-item {

  font-size: 18/@w;
  height: 44/@w;
  line-height: 44/@w;
  cursor: pointer;
}
.dp-left,.dp-center{
  color: #333;
}
.dp-right{
  color: #5890ff;
}
.dp-content {
  display: flex;
  width: 100%;
  box-align: center;
  align-items: center;
  padding: 10/@w 0;
}

.dp-header .dp-item,
.dp-content .dp-item {
  box-sizing: border-box;
  flex: 1;
  text-align: center;
}

.vux-datetime .vux-input-icon {
  float: right;
}

.vux-cell-primary {
  flex: 1;
}
.cvux-datetime-placeholder {
  color: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// datetime.vue?2a53f8ca